import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { PageMetadataProvider } from '../context/PageMetadataContext';
import './App.css';
import Header from './Header';
import Footer from './Footer';
import HomePage from '../pages/HomePage';
import BioPage from '../pages/BioPage';
import StaticFallback from './StaticFallback';

const App = () => {
  return (
    <PageMetadataProvider>
    <Router>
      <div className="app">
        {/* Skip to content link for accessibility */}
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>
        <Header />
        <main id="main-content" className="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/bio" element={<BioPage />} />
            {/* Catch-all route: fallback to static HTML files for unmatched routes */}
            <Route path="*" element={<StaticFallback />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
    </PageMetadataProvider>
  );
};

export default App;

